import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { BackIcon, SpinnerIcon } from '../../../../../assets/icons/iconshere'
import { BreadLeftArrow, BreadRightArrow, CancelIcon, EXLDownloadIcon, PDFDownloadIcon, SearchesCIcon } from '../../../../../SvgIconsData'
import {useParams, useNavigate, useLocation } from 'react-router-dom';
import { defaultLogo } from '../../../../../env';
import axios from 'axios';
import { exportMultipleChartsToPdf } from '../../../../../utils/pdf';
import moment from 'moment';

const QuizDetailedView = () => {
    const userData = useSelector((state) => state.userSlice);
    const configData = useSelector((state) => state.configSlice);
    const navigate = useNavigate();
    const location = useLocation();
    const { group, module } = location.state;
    const [search, setSearch] = useState("");
    const [list, setList] = useState([]);
    const [spinnerList, setSpinnerList] = useState([]);
    const [spinner, setSpinner] = useState(false);
    const params = useParams();
    const {groupId, resourceId} = params;


    const getQuizAttemptedList = async() =>{
        try {
            let { data } = await axios.get(`${configData.config.API_URL}/api/analytics/group/quiz/list/${groupId}/${resourceId}`,{
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json",
                  }
            });

            setList(data.data);
            
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
             if(groupId) getQuizAttemptedList();
    },[groupId]);

    const downloadPdf = async() =>{
        setSpinner(true);
        const tableData1 = [
            ["User Quiz Attempt List", ""],
            ["Group name", group],
            ["Module name", module],
            ["Time", moment(new Date()).format("DD/MM/YYY hh:mm a")],
        ];
        
        let arr = [];
        
        list.map((item, index)=>{
            arr.push([
                index+1,
                item.name,
                item.total,
                item.top,
                item.average
              ]);
          });

        const tableData2 = [["S.No", "Name", "Attempt Count", "Top Score", "Average Score"], ...arr];
        await exportMultipleChartsToPdf("Group", tableData1, tableData2);
        setSpinner(false);

    }

    const downloadUserPdf = (list, name) =>{
        const tableData1 = [
            ["Quiz attempt list", ""],
            ["Name", name],
            ["Group name", group],
            ["Module name", module],
            ["Time", moment(new Date()).format("DD/MM/YYY hh:mm a")],
        ];
        
        let arr = [];
        
        list.map((item, index)=>{
            const percentageValue = (item.achieve / item.total) * 100;
            const percentage = Number.isInteger(percentageValue) ? `${percentageValue}%` : `${percentageValue.toFixed(2)}%`;
            arr.push([
                "Attempt No: " + `${list.length-index}`,
                item.achieve+"/"+item.total,
                percentage,
                moment(item.createdAt).format("DD/MM/YYY hh:mm a"),
              ]);
          })

        const tableData2 = [["Attempt No", "Score/Total", "Percentage", "Date"], ...arr];
        exportMultipleChartsToPdf(name, tableData1, tableData2);
    }

    const handleClickPdfDownload = async(item) =>{
            try {
                if(spinnerList.includes(item.userId)) return;
                setSpinnerList((preState)=> [...preState, item.userId])
                let { data } = await axios.get(`${configData.config.API_URL}/api/quiz/user/list/${item.userId}/${resourceId}`,{
                    headers: {
                        Authorization: `Bearer ${userData.token}`,
                        "Content-Type": "application/json",
                      }
                });
                let list = data.data;
                downloadUserPdf(list, item.name);
            } catch (error) {
                console.log(error);
            }finally{
                setSpinnerList((preState)=> preState.filter(e => e != item.userId))
            }
    }

  return (
    <div className="container-fluid dashboard p-4 pt-2 pb-2 bg-grey-main">
     <div className='col-12 d-flex align-items-center justify-content-start mt-2'>
        <div className="nav-btw">
         <span onClick={() => navigate(-1)}>
           <BreadLeftArrow />
         </span>
        </div>
        <div className="breadcrums">
            <span>
            <span> {group} </span>
            <BreadRightArrow />
            </span>
            <span >
            <span> {module} </span>
            <BreadRightArrow />
            </span>
            <span className='active'>
            <span> list </span>
            </span>
        </div>
     </div>


     <div className='col-12 d-flex align-items-center justify-content-end'>
            <span className="d-flex align-items-center justify-content-center gap-2">
            { list.length > 0 &&
                <>
                    <form className=" app-search app-search1 d-flex justify-content-end ">
                        <div className="position-relative">
                        <SearchesCIcon />
                        {search.length > 0 && (
                            <span className="searchiconcancel" onClick={() => setSearch("")}>
                            <CancelIcon />
                            </span>
                        )}
                        <input
                            type="text"
                            value={search}
                            name="searchName"
                            className="form-control"
                            placeholder="Search"
                            autoComplete="off"
                            onChange={(e) => setSearch(e.target.value)}
                        />
                        </div>
                    </form>

                    <button className="DefaultRedBtn download px-2" title="Download PDF" onClick={downloadPdf}>
                    {spinner ? <SpinnerIcon /> : <PDFDownloadIcon /> }
                    </button>
                </> }
            </span>
     </div>
     <div className='col-12'>
        <div className="table-responsive workflowtb mt-2 stickyhead reports timesplayed">
            <table className="table align-middle table-nowrap mb-0">
             <thead>
              <tr>
                <th> <div className="text-center">S.No.</div> </th>
                <th> <div>User Name</div> </th>
                <th> <div className="text-center">Attempt Count</div> </th>
                <th> <div className="text-center">Top Score</div> </th>
                <th> <div className="text-center">Average Score</div> </th>
                <th> <div className="text-center">Reports</div> </th>
              </tr>      
             </thead>

             <tbody>
                {list.map((item ,index)=>{
                    if(!item.name.toLowerCase().includes(search.toLowerCase())) return;
                    let placeholderName = item.name.split(' ').slice(0,2).map(word => word[0].toUpperCase()).join('');
                    return(
                        <tr>
                            <td> <div className="text-center">{index+1}</div> </td>
                            <td> <div className='nameimage'>
                                    <span className='initials-placeholder'> {placeholderName} </span>
                                    {item.name}
                                </div>
                            </td>
                            <td> <div className="text-center">{item.total}</div> </td>
                            <td> <div className="text-center">{item.top}</div> </td>
                            <td> <div className="text-center"> {item.average} </div> </td>
                            
                            <td className="d-flex align-items-center justify-content-center gap-2">
                            <button className="DefaultRedBtn download px-2" title="Download PDF" onClick={()=>handleClickPdfDownload(item)}>
                                {spinnerList.includes(item.userId) ? <SpinnerIcon /> :<PDFDownloadIcon /> }
                            </button>
                            </td>

                        </tr>
                    )
                })}
                
             </tbody>
            </table>
        </div>
        
    </div>
    </div>
  )
}

export default QuizDetailedView
